export const CSV_HEADERS = [
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "phone" },
    { label: "Facility Name", key: "centerName" },
    { label: "Website URL", key: "websiteURL" },
    { label: "Address", key: "Address" },
    { label: "Zip", key: "zip" },
    { label: "Sale Representative", key: "saleRepresentative" },
    { label: "Sale Director", key: "saledirector" },
    { label: "Center of Excellence", key: "centerOfExcellence" },
    { label: "Speciality", key: "speciality" },
    { label: "Practice Email", key: "practiceEmail" }
    // { label: "Date", key: "updatedate" },
  ];


// WEBPACK FOOTER //
// ./src/constant.js